var pageProgress = {
    controller : function PageProgressCtrl ($element) {

        var ctrl = this,
            bar;

        function init () {
            ctrl.progress = 0;
        }

        function link () {
            bar = $element[0].querySelector('.progress-bar');
            bar.addEventListener('click', onBarClick);
            window.addEventListener('scroll', setProgress);
            window.addEventListener('resize', setProgress);
            setProgress();
        }

        function setProgress () {
            try {
                var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop; // For ie 11
                ctrl.progress = scrollTop / (document.body.offsetHeight - window.innerHeight) * 100;
                bar.style.width = ctrl.progress + "%";
                $scope.$digest();
            }
            catch (e) {
                // console.log("Waa");
            }
        }

        function onBarClick (event) {
            TweenMax.to(window, .35, {scrollTo:{x:0, y:0}});
        }

        this.$postLink = link;
        this.$onInit = init;
    },
    template : '<div class="progress-bar hide-from-print"></div>'
};